import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.concat.js";
/* eslint-disable */
import editorStyle from "../util/defaultStyle";
import Anchor from '../item/anchor';
var dashArray = [[0, 1], [0, 2], [1, 2], [0, 1, 1, 2], [0, 2, 1, 2], [1, 2, 1, 2], [2, 2, 1, 2], [3, 2, 1, 2], [4, 2, 1, 2]];
var interval = 9;
var lineDash = [4, 2, 1, 2];
var nodeDefinition = {
  options: {
    icon: null,
    iconStyle: {
      width: 14,
      height: 14,
      left: 0,
      top: 0
    },
    style: {
      fill: '#f9f9f9',
      stroke: '#bbb',
      cursor: 'default'
    },
    stateStyles: {
      selected: {
        fill: '#eee'
      },
      hover: {
        cursor: editorStyle.cursor.hoverNode
      }
    }
  },
  drawAnchor: function drawAnchor(group) {
    var bbox = group.get('children')[0].getBBox();
    this.getAnchorPoints().forEach(function (p, i) {
      var anchorContainer = group.addGroup();
      var anchor = new Anchor({
        group: anchorContainer,
        index: i,
        model: {
          style: {
            x: bbox.minX + bbox.width * p[0],
            y: bbox.minY + bbox.height * p[1]
          }
        }
      });
      group.anchorShapes.push(anchorContainer);
    });
  },
  initAnchor: function initAnchor(group) {
    var _this = this;
    group.anchorShapes = [];
    group.showAnchor = function () {
      _this.drawAnchor(group);
    };
    group.getAllAnchors = function () {
      return group.anchorShapes.map(function (c) {
        c.filter(function (a) {
          return a.isAnchor;
        });
      });
    };
    group.getAnchor = function (i) {
      return group.anchorShapes.filter(function (a) {
        return a.get('index') === i;
      });
    };
    group.clearAnchor = function () {
      group.anchorShapes && group.anchorShapes.forEach(function (a) {
        return a.remove();
      });
      group.anchorShapes = [];
    };
    group.clearHotpotActived = function () {
      group.anchorShapes && group.anchorShapes.forEach(function (a) {
        if (a.isAnchor) a.setHotspotActived(false);
      });
    };
  },
  drawShape: function drawShape(cfg, group) {
    var shapeType = this.shapeType;
    var style = this.getShapeStyle(cfg);
    var shape = group.addShape(shapeType, {
      attrs: _objectSpread({}, style)
    });
    this.drawIcon(cfg, group);
    this.initAnchor(group);
    return shape;
  },
  drawIcon: function drawIcon(cfg, group) {
    var style = this.getShapeStyle(cfg);
    if (this.options.icon) {
      var attrs = {
        x: style.x + this.options.iconStyle.left,
        y: style.y + this.options.iconStyle.top,
        width: this.options.iconStyle.width,
        height: this.options.iconStyle.height
      };
      if (this.shapeType === 'circle') {
        attrs = {
          x: style.x - style.r + this.options.iconStyle.left,
          y: style.y - style.r + this.options.iconStyle.top,
          width: this.options.iconStyle.width,
          height: this.options.iconStyle.height
        };
      } else if (this.shapeType === 'path') {
        attrs = {
          x: this.options.iconStyle.left,
          y: this.options.iconStyle.top,
          width: this.options.iconStyle.width,
          height: this.options.iconStyle.height
        };
      }
      group.icon = group.addShape('image', {
        attrs: _objectSpread({
          img: this.options.icon
        }, attrs),
        draggable: true
      });
      if (cfg.hideIcon) {
        group.icon.hide();
      }
    }
  },
  setState: function setState(name, value, item) {
    var group = item.getContainer();
    if (name === 'show-anchor') {
      if (value) {
        group.showAnchor();
      } else {
        group.clearAnchor();
      }
    } else if (name === 'selected') {
      var rect = group.getChildByIndex(0);
      if (value) {
        rect.attr('fill', this.options.stateStyles.selected.fill);
      } else {
        rect.attr('fill', this.options.style.fill);
      }
    } else if (name === 'hover') {
      var _rect = group.getChildByIndex(0);
      var text = group.getChildByIndex(1);
      if (value) {
        _rect.attr('cursor', this.options.stateStyles.hover.cursor);
        if (text) text.attr('cursor', this.options.stateStyles.hover.cursor);
      } else {
        _rect.attr('cursor', this.options.style.cursor);
        if (text) text.attr('cursor', this.options.style.cursor);
      }
    }
    this.setCustomState(name, value, item);
  },
  setCustomState: function setCustomState(name, value, item) {},
  getAnchorPoints: function getAnchorPoints() {
    return [[0.5, 0],
    // top
    [1, 0.5],
    // right
    [0.5, 1],
    // bottom
    [0, 0.5] // left
    ];
  },
  runAnimate: function runAnimate(cfg, group) {
    if (cfg.active) {
      var totalArray = [];
      var index = 0;
      var shape = group.getFirst();
      shape.animate(function (ratio) {
        for (var i = 0; i < 9; i += interval) {
          totalArray = totalArray.concat(lineDash);
        }
        var cfg = {
          lineDash: dashArray[index].concat(totalArray)
        };
        index = (index + 1) % interval;
        return cfg;
      }, {
        repeat: true,
        duration: 5000
      });
    }
  },
  afterDraw: function afterDraw(cfg, group) {
    this.runAnimate(cfg, group);
  },
  afterUpdate: function afterUpdate(cfg, group) {
    var icon = group.get('group').icon;
    if (cfg.hideIcon && icon && icon.get('visible')) {
      icon.hide();
    } else if (!cfg.hideIcon && icon && !icon.get('visible')) {
      icon.show();
    }
  }
};
export default function (G6) {
  G6.registerNode('base-node', nodeDefinition, 'single-node');
}